/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
 import React from "react";
 import styled from "@mui/styled-engine-sc";
 import { StyledGrid, StyledTypography } from "@hcl-commerce-store-sdk/react-component";
 import { StyledPaper } from "@hcl-commerce-store-sdk/react-component";
 import { StyledLink } from "@hcl-commerce-store-sdk/react-component";
 import { StyledTooltip } from "@hcl-commerce-store-sdk/react-component";
 
 const StyledAccountLink = styled(({ ...props }) => <StyledLink {...props} />)`
   ${({ theme }) => `
     color: ${theme.palette.text.primary};
     display: block;
 
     &:hover {
       h6, p {
         color: ${theme.palette.primary.dark};
       }
     }
   `}
 `;
 
 const StyledLinkBoxWrapper = styled(({ ...props }) => <StyledPaper {...props} />)`
   ${({ theme }) => `
   box-shadow: none;
 
   .styled-box-wrapper {
     display: flex;
     position: relative;
     padding: ${theme.spacing(2)};
     align-items: center;
     justify-content: center;
     min-width: 220px;
     max-width: 220px;
     min-height: 142px;
     max-height: 120px;
     background-color: #F1F1F1;
     border-radius: 4px;
 
     .link-box-icon-container {
       padding: 0px 0px 5px 0px;
     }
 
     .link-box-icon-unselected {
       height: 50px;
       display: flex;
       position: relative;
       text-align: center;
       justify-content: center;
       align-items: center;
 
       .MuiSvgIcon-root {
         font-size: 50px;
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         color: #000000;
       }
 
       img {
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         width: auto;
         height: 37px !important;
       }
     }
 
     .link-box-icon-selected {
       height: 50px;
       display: none;
       position: relative;
       text-align: center;
       justify-content: center;
       align-items: center;
 
       .MuiSvgIcon-root {
         font-size: 50px;
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         color: #000000;
       }
     }
 
     .link-box-title {
       text-align: center;
       font-size: 18px;
       font-weight: 500;
     }
   }
 
   .styled-box-wrapper: hover {
     background-color: #263645;
 
     .link-box-icon-unselected {
       display: none;
       color: white;
       .MuiSvgIcon-root {
         color: white;
       }
     }
 
     .link-box-icon-selected {
       display: flex;
       color: white;
       .MuiSvgIcon-root {
         color: white;
       }
       img {
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         width: auto;
         height: 37px;
       }
     }
 
     .link-box-title {
       color: white;
     }
   }
 
 
   .styled-box-wrapper-selected {
     display: flex;
     position: relative;
     padding: ${theme.spacing(2)};
     align-items: center;
     justify-content: center;
     min-width: 220px;
     max-width: 220px;
     min-height: 142px;
     max-height: 120px;
     background-color: #263645;
     border-radius: 4px;
 
     .link-box-icon-container {
       padding: 0px 0px 5px 0px;
     }
 
     .link-box-icon-unselected {
       height: 50px;
       display: none;
       color: white;
       position: relative;
       text-align: center;
       justify-content: center;
       align-items: center;
 
       .MuiSvgIcon-root {
         color: white;
         font-size: 50px;
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
       }
 
       img {
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         width: auto;
         height: 37px !important;
       }
     }
 
     .link-box-icon-selected {
       height: 50px;
       display: flex;
       color: white;
       position: relative;
       text-align: center;
       justify-content: center;
       align-items: center;
 
       .MuiSvgIcon-root {
         font-size: 50px;
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         color: white;
       }
 
       img {
         position: relative;
         text-align: center;
         justify-content: center;
         align-items: center;
         width: auto;
         height: 37px !important;
       }
     }
 
     .link-box-title {
       color: white;
       text-align: center;
       font-size: 18px;
       font-weight: 500;
     }
   }
 
 
   &.disabled {
     h6, p {
       color: ${theme.palette.text.disabled};
     }
 
     .MuiSvgIcon-root {
       color: ${theme.palette.text.disabled};
     }
   }
   `}
 `;
 
 const StyledLinkIcon = styled("div")`
   ${({ theme }) => `
     position: relative;
     text-align: center;
     justify-content: center;
     align-items: center;
 
     .MuiSvgIcon-root {
       font-size: 50px;
       position: relative;
       text-align: center;
       justify-content: center;
       align-items: center;
       color: ${theme.palette.primary.main};
     }
 
   `}
 `;
 
 interface LinkBoxProps {
   title: string;
   disabledTitle: string;
   url: string;
   iconUnselected: any;
   iconSelected: any;
   disabled?: boolean;
   currentURL: string;
 }
 
 export function StyledLinkBox({
   title,
   disabledTitle,
   disabled,
   currentURL,
   iconUnselected,
   iconSelected,
   url,
 }: LinkBoxProps) {
   const selected = currentURL === url ? true : false;
 
   const LinkTextElements = (
     <>
       <StyledTypography style={{ fontSize: "18px", fontWeight: 500 }}>{title}</StyledTypography>
     </>
   );
 
   const LinkContent = (
     <StyledLinkBoxWrapper className={disabled ? "disabled" : ""}>
       <StyledGrid
         container
         className={selected ? "styled-box-wrapper-selected" : "styled-box-wrapper"}
         direction="column"
         justifyContent="center">
         <StyledGrid item className="link-box-icon-container" alignItems="center">
           <div className="link-box-icon-unselected">{iconUnselected}</div>
           <div className="link-box-icon-selected">{iconSelected}</div>
         </StyledGrid>
         <StyledGrid item alignItems="center" justifyContent="center">
           <div className="link-box-title">{title}</div>
         </StyledGrid>
       </StyledGrid>
     </StyledLinkBoxWrapper>
   );
 
   return disabled ? (
     <StyledTooltip title={disabledTitle}>
       <div>{LinkContent}</div>
     </StyledTooltip>
   ) : (
     <StyledAccountLink to={url}>{LinkContent}</StyledAccountLink>
   );
 }
 